module.exports = __webpack_public_path__ + "static/media/ryan-lamb-archi.36809284.png";